/**
 * <notify-me-form>
 * Back-in-stock request using Shopify's native contact form.
 *
 * The form submits natively on purpose: the store has Shopify spam protection (hCaptcha) enabled
 * on contact forms, and Shopify rejects fetch/XHR posts to /contact with 400 because they carry no
 * captcha token. Shopify then redirects to ?contact_posted=true#<form id>; the variant id is part of
 * the form id and a small inline script in layout/theme.liquid restores ?variant= before first paint,
 * so the shopper lands back on the same sold-out variant with the confirmation shown.
 *
 * The element is re-created by product-info.js on every variant change
 * (the whole #SoldOutActions-{section} block is swapped), so state is per-variant.
 */
if (!customElements.get('notify-me-form')) {
  customElements.define(
    'notify-me-form',
    class NotifyMeForm extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('[data-notify-details]');
        this.form = this.querySelector('form');
        this.emailInput = this.form?.querySelector('input[type="email"]');
        this.submitButton = this.form?.querySelector('[type="submit"]');
        this.message = this.querySelector('[data-notify-message]');

        // <details> handles open/close natively; we only react to it.
        this.details?.addEventListener('toggle', () => {
          this.classList.toggle('notify-me--open', this.details.open);
          if (this.details.open) this.emailInput?.focus({ preventScroll: true });
        });

        // Native submit – just show the loading state while Shopify (and its captcha) do their thing.
        this.form?.addEventListener('submit', () => {
          if (!this.form.checkValidity()) return;
          this.setLoading(true);
        });

        // Back from Shopify: ?contact_posted=true#<this form id> (success markup is rendered by Liquid),
        // or the page re-rendered with a server-side validation error. Open the panel in both cases.
        const postedBack =
          window.location.search.includes('contact_posted=true') && window.location.hash === `#${this.form?.id}`;
        const hasServerError = this.message && !this.message.hasAttribute('hidden');
        if (postedBack || hasServerError) {
          this.setOpen(true);
          if (postedBack) this.classList.add('notify-me--done');
        }
      }

      setOpen(open) {
        if (this.details) this.details.open = open;
      }

      setLoading(loading) {
        if (!this.submitButton) return;
        this.submitButton.disabled = loading;
        this.submitButton.classList.toggle('btn--loading', loading);
        this.submitButton.setAttribute('aria-busy', String(loading));
      }
    }
  );
}